import { Dispatch } from "redux";
import {IUtm, IUtmFull} from "../../models/utm.interface";
import { UtmActionTypes } from "./types";
import { utmService } from "../../services/utm.services";

export interface UtmAction {
    type: UtmActionTypes;
    payload: IUtm | null;
}

export const utmActions = {
    setUtm: (campaign:string, source: string, medium: string, adgroup: string, keyword: string, gclid:string, fallback:string, agent: string) => {
        return async (dispatch: Dispatch) => {
            dispatch<UtmAction>({
                type: UtmActionTypes.SET_UTM,
                payload: {campaign, source, medium, adgroup, keyword, gclid, fallback, agent}
            });
        };
    },
    getUtm:async (): Promise<IUtmFull> => {
        return await utmService.getUtmSecureCookieValues();
    }
};
